<template>
  <div class="password">

    <!-- Header -->
    <div class="password__line">
      <h1 class="password__line-title">
        {{ $t('Change password') }}
      </h1>
    </div>
    <!---->

    <!-- Edit information block -->
    <section class="password__block">
      <base-input
        class="col-xs-12 mb10 input password__block-field"
        type="password"
        name="old-password"
        autocomplete="current-password"
        :placeholder="$t('Current password *')"
        v-model="oldPassword"
        @input="$v.oldPassword.$touch()"
        :validations="[
          {
            condition: !$v.oldPassword.required && $v.oldPassword.$error,
            text: $t('Field is required')
          }
        ]"
      />

      <!-- New password field -->
      <base-input
        class="col-xs-12 mb10 input password__block-field"
        type="password"
        name="password"
        autocomplete="new-password"
        :placeholder="$t('New password *')"
        v-model="password"
        @input="$v.password.$touch()"
        :validations="[
          {
            condition: !$v.password.required && $v.password.$error,
            text: $t('Field is required')
          },
          {
            condition: $v.password.$error && !$v.password.minLength,
            text: $t('Password must have at least 8 letters.')
          }
        ]"
      />
      <!---->

      <!-- New password confirm field -->
      <base-input
        class="col-xs-12 mb10 input password__block-field"
        type="password"
        name="password-confirm"
        autocomplete="new-password"
        :placeholder="$t('Repeat new password *')"
        v-model="rPassword"
        @input="$v.rPassword.$touch()"
        :validations="[
          {
            condition: !$v.rPassword.required && $v.rPassword.$error,
            text: $t('Field is required')
          },
          {
            condition: $v.rPassword.required && !$v.rPassword.sameAsPassword,
            text: $t('Passwords must be identical.')
          }
        ]"
      />
      <!---->

      <!-- Accept button -->
      <div class="password__block-actions">
        <button-full class="password__block-actions_btn" :disabled="!hasValidChanges" @click.native="confirmUpdate">
          {{ $t('Confirm changes') }}
        </button-full>
      </div>
      <!---->

    </section>
    <!---->
  </div>
</template>

<script async>
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import MyProfile from '@vue-storefront/core/compatibility/components/blocks/MyAccount/MyProfile';

const ButtonFull = () => import(/* webpackChunkName: "vsf-button-full" */ 'theme/components/theme/ButtonFull');
const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  name: 'MyPassword',
  components: {
    ButtonFull,
    BaseInput
  },
  mixins: [MyProfile],
  computed: {
    hasValidChanges () {
      return !this.$v.oldPassword.$invalid && !this.$v.password.$invalid && !this.$v.rPassword.$invalid;
    }
  },
  methods: {
    confirmUpdate () {
      this.$v.oldPassword.$touch();
      this.$v.password.$touch();
      this.$v.rPassword.$touch();

      const isValid = !this.$v.oldPassword.$invalid && !this.$v.password.$invalid && !this.$v.rPassword.$invalid;
      if (!isValid) {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Some of the form fields are not valid!'),
          action1: { label: this.$t('OK') }
        })
        return;
      }
      this.updateProfile();
    }
  },
  validations () {
    return {
      oldPassword: {
        required
      },
      password: {
        required,
        minLength: minLength(8)
      },
      rPassword: {
        required: () => required && !this.$v.password.$invalid && this.password,
        sameAsPassword: sameAs('password')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.password {
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 576px) {
    padding: 0 20px;
  }

  &__line {
    height: 60px;
    margin-bottom: 20px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    @media only screen and (max-width: 576px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    &-title {
      margin: 0;

      color: #111;
      font-size: 20px;
      font-weight: 600;

      @media only screen and (max-width: 576px) {
        display: none;
      }
    }
  }

  &__block {

    &-actions {
      display: flex;
      justify-content: center;

      &_btn {
        width: auto;
        padding: 16px 84px;

        font-size: 16px;
        font-weight: 400;
        border-radius: 5px;
      }
    }

    &-field {
      padding: 0;
    }
  }
}
</style>
